<template>
  <b-card>
    <b-row>
      <b-col sm="12">
        <html-content
          api="https://api.Кавказский стиль.ru/api/v1/htm/app/service/page/link/confidence"
        />
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'

import HtmlContent from '@core/components/html-content/HtmlContent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    HtmlContent,
  },
}
</script>
